import React from 'react'
import { IconTypeProps } from '../icon';

export function IconArrowRight({
  onClick = () => {},
  className = '',
  ...rest
}: IconTypeProps) {
  return (
    <svg
      className={className}
      onClick={onClick}
      viewBox='0 0 6 11'
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M0.181641 0L5.36363 5.18198L0.181641 10.364V5.18198V0Z" />
    </svg>
  );
}
